/* eslint-disable import/prefer-default-export */
import { StepStatus } from '@xhs/yam-beer/cmp/constants'

export function getCurrentStatus(
  status: StepStatus | undefined,
  itemIndex: number,
  currentStep: number,
): StepStatus {
  if (status) return status
  let currentStatus = null
  if (itemIndex < currentStep) {
    currentStatus = StepStatus.DONE
  } else if (itemIndex === currentStep) {
    currentStatus = StepStatus.PROGRESS
  } else {
    currentStatus = StepStatus.PENDING
  }
  return currentStatus
}
